export default function getFileType(title: string): string {
  const extension = title.split(".").pop()?.toLowerCase();
  return extension || "";
}
